
const nameList = [
    {
        entityField: "capCode",
        showField: "卡类型编号",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "capName",
        showField: "卡类型名称",
        fieldWeight: 130,
        fieldType: "string",

    },
    // {
    //     entityField: "discount",
    //     showField: "扣率",
    //     fieldWeight: 130,
    //     fieldType: "string",

    // },
    // {
    //     entityField: "isDiscont",
    //     showField: "是否折扣",
    //     fieldWeight: 130,
    //     fieldType: "string",

    // },
    {
        entityField: "isMeprice",
        showField: "是否会员价",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "isPwd",
        showField: "是否使用密码",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "isStored",
        showField: "是否储值",
        fieldWeight: 100,
        fieldType: "string",

    },

    


]



const  searchList= [
    // {
    //     showField: "开始时间",
    //     entityField: "start",
    //     isShow: 1,
    //     fieldType: "date",
    //     formatterContent: null,
    //     isRift: null,
    //     riftField: null,
    //     fieldWeight: 120,
    // },
    // {
    //     showField: "结束时间",
    //     entityField: "end",
    //     isShow: 1,
    //     fieldType: "date",
    //     formatterContent: null,
    //     isRift: null,
    //     riftField: null,
    //     fieldWeight: 120,
    // },
   
    {
        showField: "卡类型名称",
        entityField: "capName",
        isShow: 1,
        fieldType: "string",
        searchId: null,
        formatterContent: null,
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },

    // {
    //     showField: "货主",
    //     entityField: "coName",
    //     isShow: 1,
    //     fieldType: "search",
    //     searchId: 4414428383875072,
    //     formatterContent: null,
    //     isRift: null,
    //     riftField: null,
    //     setField:  "coName,coId",
    //     fieldWeight: 120,
    // },
   
    // {
    //     showField: "门店类型",
    //     entityField: "storeType",
    //     isShow: 1,
    //     fieldType: "select",
    //     searchId: null,
    //     formatterContent: [
    //         {
    //             key: "单体",
    //             value: '单体',
    //         },
    //         {
    //             key: "加盟",
    //             value: "加盟",
    //         },
    //         {
    //             key: "直营",
    //             value: "直营",
    //         },
    //         {
    //             key: "批零一体",
    //             value: "批零一体",
    //         },
    //     ],
    //     isRift: null,
    //     riftField: null,
    //     setField: null,
    //     fieldWeight: 120,
    // },
]




// 门店列表
// 业务员列表
export {nameList,searchList}